export var APIErrorType = /*#__PURE__*/function (APIErrorType) {
  APIErrorType["SERVER_ERROR"] = "server error";
  APIErrorType["NETWORK_ERROR"] = "network error";
  return APIErrorType;
}({});
export var APIErrorCode = /*#__PURE__*/function (APIErrorCode) {
  APIErrorCode["FAIL"] = "fetch_fail";
  APIErrorCode[APIErrorCode["USER_NOT_EXIST"] = 98001006] = "USER_NOT_EXIST";
  return APIErrorCode;
}({});
export var PageStateEnum = /*#__PURE__*/function (PageStateEnum) {
  PageStateEnum[PageStateEnum["INIT"] = 0] = "INIT";
  PageStateEnum[PageStateEnum["READY"] = 1] = "READY";
  PageStateEnum[PageStateEnum["LOADING"] = 2] = "LOADING";
  PageStateEnum[PageStateEnum["SERVER_ERROR"] = 3] = "SERVER_ERROR";
  PageStateEnum[PageStateEnum["NETWORK_ERROR"] = 4] = "NETWORK_ERROR";
  return PageStateEnum;
}({});